import { updateAnalyzerProperties } from '../spectrasWebSocketServer/spectrasWebSocketServerSlice';

import { Autocomplete, ListItem, TextField } from '@mui/material';

import { useAppDispatch, useAppSelector } from '../../app/hooks';

import { useAnalyzer } from 'features/analyzers/api/getAnalyzer';
import { useUpdateAnalyzer } from '../analyzers/api/updateAnalyzer';
import { useSnapshots } from 'features/snapshots/api/getSnapshots';
import { useWindow } from 'features/windows/api/getWindow';
import { useUpdateWindow } from 'features/windows/api/updateWindow';
import { Snapshot } from 'types';

interface Props {
  disabled: boolean;
}

const ActiveSnapshotSelect = ({ disabled }: Props) => {
  const dispatch = useAppDispatch();

  const { user } = useAppSelector((state) => state.auth);

  const selectedAnalyzerId = useAppSelector(
    (state) => state.analyzers.selectedAnalyzerId
  );

  const { data: selectedAnalyzer } = useAnalyzer({
    analyzerId: selectedAnalyzerId,
  });
  const { selectedWindowId } = useAppSelector((state) => state.windows);
  const { data: selectedWindow } = useWindow({ windowId: selectedWindowId });
  const { data: snapshots, isLoading: isSnapshotsLoading } = useSnapshots({
    analyzerId: selectedAnalyzerId,
  });
  const updateAnalyzerMutation = useUpdateAnalyzer({});
  const updateWindowMutation = useUpdateWindow({});

  const handleChange = async (e: React.SyntheticEvent, v: Snapshot | null) => {
    if (!snapshots || !user || !v) return;
    const snapshotId = v.id;
    const selectedSnapshot = snapshots.find(
      (snapshot) => snapshot.id === Number(snapshotId)
    );

    if (selectedAnalyzer?.mode === 0) {
      await updateAnalyzerMutation.mutateAsync({
        data: {
          ...selectedAnalyzer,
          active_snapshot: Number(snapshotId),
          enabled: !!selectedAnalyzer.enabled,
        },
        analyzerId: selectedAnalyzer.id,
      });
      if (selectedSnapshot)
        dispatch(
          updateAnalyzerProperties({
            user_id: user.id,
            properties: selectedSnapshot,
            analyzer: selectedAnalyzer,
          })
        );
      if (selectedWindow)
        await updateWindowMutation.mutateAsync({
          data: {
            ...selectedWindow,
            snapshot_id: Number(snapshotId),
          },
          windowId: selectedWindow?.id,
        });
    } else if (selectedAnalyzer?.mode === 1) {
      if (selectedWindow)
        await updateWindowMutation.mutateAsync({
          data: {
            ...selectedWindow,
            snapshot_id: Number(snapshotId),
          },
          windowId: selectedWindow.id,
        });

      if (selectedSnapshot)
        dispatch(
          updateAnalyzerProperties({
            user_id: user.id,
            properties: selectedSnapshot,
            analyzer: selectedAnalyzer,
          })
        );
    }
  };

  if (isSnapshotsLoading) return <></>;

  return (
    <Autocomplete
      value={snapshots?.find(
        (snapshot) => snapshot.id === selectedWindow?.snapshot_id
      )}
      onChange={handleChange}
      options={snapshots || []}
      getOptionLabel={(snapshot) => snapshot.name}
      renderInput={(params) => (
        <TextField {...params} label='Active Snapshot' />
      )}
      fullWidth
      disableClearable
      size='small'
      renderOption={(props, option) => (
        <ListItem {...props} key={option.id}>
          {option.name}
        </ListItem>
      )}
    />
  );
};

export default ActiveSnapshotSelect;
